<template>
    <div>
        <div class="flex -mx-1 mb-4">
            <div class="form-group w-1/2 pl-1 pr-16">
                <label for="location_id" class="form-label">Lokacija</label>
                <input
                    type="hidden"
                    name="location_id"
                    :value="selected_location"
                >
                <v-select
                    id="location_id"
                    :filterable="false"
                    v-model="selected_location"
                    :disabled="disableEdit() || isWarehouseUser"
                    :options="location"
                    :reduce="item => item.value"
                    @input="() => {
                        fetchAvailableProducts('return_revers')
                        fetchAvailableProducts('service')
                    }"
                    @search="locationSearch"
                >
                    <template slot="no-options">
                        Pretraživanje lokacija
                    </template>
                </v-select>
            </div>

          <div class="form-group w-1/4 px-1">
            <label for="planned_for" class="form-label">Datum zaprimanja</label>
            <datetime
                type="datetime"
                input-id="planned_for"
                hidden-name="planned_for"
                input-class="form-control mb-1"
                :disabled="disableEdit()"
                v-model="planned_for"
            ></datetime>
          </div>
          <div class="form-group w-1/4 px-1">
            <label for="planned_end" class="form-label">Planirani završetak</label>
            <datetime
                type="datetime"
                input-id="planned_end"
                hidden-name="planned_end"
                input-class="form-control mb-1"
                :disabled="disableEdit()"
                v-model="planned_end"
            ></datetime>
          </div>
        </div>

        <div class="flex -mx-1 mb-4">
            <div class="form-group w-1/2 pl-1 pr-16">
                <label for="company_id" class="form-label">Poduzeće</label>
                <input type="hidden" name="company_id" :value="selected_company">
                <v-select
                    id="company_id"
                    :filterable="false"
                    v-model="selected_company"
                    :disabled="disableEdit() || isWarehouseUser"
                    :options="company"
                    :reduce="item => item.value"
                    @input="installersSearch('', '')"
                    @search="companySearch"
                >
                    <template slot="no-options">
                        Pretraživanje poduzeća
                    </template>
                </v-select>
            </div>

            <div class="form-group w-1/2 pl-1 pr-16">
                <label for="installer_id" class="form-label">Instalater</label>
                <input
                    type="hidden"
                    name="installer_id"
                    :value="selected_installer"
                >
                <v-select
                    id="installer_id"
                    :filterable="false"
                    v-model="selected_installer"
                    :disabled="disableInstallerSelection() || isWarehouseUser"
                    :options="installer"
                    :reduce="item => item.value"
                    @input="fetchAvailableProducts('revers')"
                    @search="installersSearch"
                >
                    <template slot="no-options">
                        Pretraživanje instalatera
                    </template>
                </v-select>
            </div>
        </div>

        <hr>

        <!-- SERVICES -->
        <div class="-mx-1">
            <div class="px-1 w-full">
                <h2 class="font-bold text-2xl">USLUGE</h2>
            </div>

            <div
                class="px-1 flex mt-2"
                v-if="selectedServices.length > 0"
                v-for="(service, index) in selectedServices"
                :key="index"
            >
                <div class="form-group w-1/3 pr-16">
                    <label :for="`service-${index}`" class="form-label">Odaberi uslugu</label>
                    <v-select
                        :id="`service-${index}`"
                        :filterable="true"
                        :options="services"
                        :reduce="service => service.id"
                        :disabled="disableEdit()"
                        v-model="service.value"
                        label="name"
                    >
                        <template slot="no-options">
                            Nema ponuđenih usluga
                        </template>
                    </v-select>
                    <input type="hidden" :name="`service[${index}][id]`" :value="service.value">
                </div>
                <div class="form-group w-1/4">
                    <label :for="`service-quantity-${index}`" class="form-label">Količina</label>
                    <input
                        type="number"
                        class="form-control"
                        :name="`service[${index}][quantity]`"
                        :disabled="disableEdit()"
                        v-model="service.quantity"
                    >
                </div>
                <div class="form-group w-1/4">
                    <label for="">&nbsp;</label>
                    <button
                        :id="`remove-service-${index}`"
                        type="button"
                        class="btn btn-delete border-0 mt-2 px-2 ml-4 hover:text-primary flex"
                        :disabled="disableEdit()"
                        @click="removeService(index)"
                    >Ukloni</button>
                </div>
            </div>
            <div class="flex w-1/5 items-center mb-1 mt-4">
                <button
                    class="btn btn-lg btn-success"
                    :disabled="disableEdit()"
                    @click.prevent="addNewService()"
                >
                    <span>Dodaj stavku</span>
                </button>
            </div>
        </div>

        <hr>

        <div class="-mx-1 mb-4">
            <input
                id="tempFile"
                name="tempFile[]"
                style="display: none;"
                accept="application/pdf,image/png"
                type="file"
                @change="processFile($event)"
                multiple="multiple"
            />

            <div class="flex ml-1 mb-2 w-1/3" :key="'preupload-' + index" v-for="(file, index) in files">
                <a
                    :href="file.full_url"
                    target="_blank"
                    class="border flex pt-3 w-full min-h-3 px-4 py-2 break-all rounded-lg"
                >{{ file.name }}</a>

                <button
                    type="button"
                    @click="removePreUploadFile(file, index)"
                    class="flex btn btn-delete border-0 mt-2"
                ></button>
            </div>
        </div>

        <div class="-mx-1">
            <div class="px-1 w-full">
                <h2 class="font-bold text-2xl">ISPORUKA</h2>
            </div>
        </div>

        <div
            class="flex flex-wrap -mx-1 mb-4 mt-4"
            v-for="(product, index) in products"
            :key="'product-' + index"
        >
            <div class="form-group w-1/6 pl-1 pr-2">
                <label for="selected_way" class="form-label">Odaberi smjer uređaja</label>
                <v-select
                    id="selected_way"
                    :filterable="false"
                    v-model="product['way']"
                    :disabled="disableEdit()"
                    :reduce="item => item.value"
                    :options="[
                        {
                            label: 'Povrat reversa',
                            value: 'return_revers'
                        },
                        {
                            label: 'Revers',
                            value: 'revers'
                        },
                        {
                            label: 'Servis',
                            value: 'service'
                        },
                    ]"
                >
                    <template slot="no-options">
                        Pretraživanje tipova opreme
                    </template>
                </v-select>
            </div>
            <div v-if="product['way']" class="form-group w-1/3 pl-1 pr-6">
                <label for="selected_product" class="form-label">Odaberi uređaj</label>
                <v-select
                    id="selected_product"
                    :filterable="false"
                    v-model="product['type']"
                    :disabled="disableEdit()"
                    :options="productTypes[product.way].types"
                    label="title"
                >
                    <template slot="no-options">
                        Nema rezultata
                    </template>
                </v-select>
            </div>
            <div v-if="product['type']" class="form-group w-1/6 pl-1 pr-12">
                <label :for="'quantity-'+ index" class="form-label">Unesi količinu</label>
                <input
                    type="number"
                    class="form-control"
                    :id="'quantity-'+ index"
                    :disabled="disableEdit()"
                    v-model="product['quantity']"
                    min="0"
                >
            </div>
            <div
                v-if="productTypes[product.way] &&
                    product['type'] &&
                    !product['type'].track_quantitatively &&
                    product['quantity'] > 0"
                class="form-group w-1/6 pl-1 pr-12"
            >
                <label :for="'qr-'+ index" class="form-label">Unesi QR</label>
                <v-select
                    :id="'qr-' + index"
                    :disabled="disableEdit()"
                    :options="product['type'] ? productTypes[product.way].equipment[product['type'].id] : []"
                    v-model="product['selected_equipment']"
                    label="label"
                >
                    <template slot="no-options">
                        Nema rezultata
                    </template>
                </v-select>

                <br>

                <button
                    class="btn btn-lg btn-success"
                    :disabled="!product['selected_equipment']"
                    @click.prevent="addEquipment(product)"
                >
                    <span>Dodaj opremu</span>
                </button>
            </div>

            <div v-if="!lessThanTwo() && !hideInstalled" class="ml-auto">
                <label :for="'remove-product-' + index" :disabled="disableEdit()" class="">&nbsp;</label>
                <button
                    :id="'remove-product-' + index"
                    type="button"
                    class="btn btn-delete border-0 my-0 py-0 px-2 hover:text-primary flex"
                    :disabled="disableEdit()"
                    @click="removeProduct(index)"
                >Ukloni uređaj</button>
            </div>

            <div class="w-1/5" v-if="product['qr_codes'].length > 0 && !product['type'].track_quantitatively">
                <span>Unosi:</span><br>
                <span v-for="(qrCode, qrIndex) in product.qr_codes" :key="'entries-' + qrIndex">
                    <div>
                        <div class="flex flex-col">
                            <div>
                                <strong>QR:</strong> {{ qrCode.code }}
                            </div>
                            <div v-if="qrCode.serial_no != ''">
                                <strong>S/N:</strong> {{ qrCode.serial_no }}
                            </div>
                            <span v-if="product.mac_addresses > 0">
                                <strong>MAC:</strong> {{ qrCode.mac_address }}
                            </span>
                            <span v-if="product.mac_addresses > 1">
                                <strong>MAC2:</strong> {{ qrCode.mac_address2 }}
                            </span>
                        </div>

                        <div v-if="!hideInstalled && isAbleToEdit" class="flex mt-2">
                            <button
                                class="review-link mr-2"
                                :disabled="disableEdit()"
                                @click.prevent="removeQr(index, qrIndex)"
                            >
                                Ukloni QR
                            </button>
                            <br>
                            <handle-file :name="'file-' + qrCode.code" :qr="qrCode.code"></handle-file>
                        </div>
                        <hr class="m-4">
                    </div>
                </span>
            </div>
        </div>

        <span v-for="(product, index) in products" :key="'products-' + index">
            <input
                type="hidden"
                :name="'products[' + index + '][id]'"
                :value="product['type'] ? product['type'].id : null"
            >
            <input
                type="hidden"
                :name="'products[' + index + '][quantity]'"
                :value="product.quantity"
            >
            <input
                type="hidden"
                :name="'products[' + index + '][label]'"
                :value="product.label"
            >
            <input
                type="hidden"
                :name="'products[' + index + '][way]'"
                :value="product.way"
            >
            <span
                v-for="(qrCode, qrIndex) in product.qr_codes"
                :key="'product-qr-' + qrIndex"
            >
                <input
                    type="hidden"
                    :name="'products[' + index + '][qr_codes][' + qrIndex + '][id]'"
                    :value="qrCode.value"
                >
                <input
                    type="hidden"
                    :name="'products[' + index + '][qr_codes][' + qrIndex + '][code]'"
                    :value="qrCode.code"
                >
                <input
                    type="hidden"
                    :name="'products[' + index + '][qr_codes][' + qrIndex + '][serial_no]'"
                    :value="qrCode.serial_no"
                >
            </span>
        </span>

        <div v-if="!hideInstalled" class="flex -mx-1 mb-4 mt-8 justify-between">
            <button
                class="btn btn-lg btn-success btn-yellow ml-1"
                :disabled="disableEdit()"
                @click.prevent="addNewProduct()"
            >
                <span>Dodaj novi uređaj</span>
            </button>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import vSelect from 'vue-select'
import { Datetime } from 'vue-datetime'
import { Settings } from 'luxon'
import axios from 'axios'
import HandleFile from './HandleFile'

Vue.component('v-select', vSelect);
Vue.component('datetime', Datetime);
Settings.defaultLocale = 'hr'

export default {
    components: {
        HandleFile,
    },

    props: {
        old: {
            required: false,
            default: null,
        },
        services: {
            type: Array,
            required: true,
        },
        isWarehouseUser: {
            type: Boolean,
            default: false,
        },
        isNetworkUser: {
            type: Boolean,
            default: false,
        },
        isLead: {
            type: Boolean,
            default: false,
        },
        oldFiles: {
            type: Array,
            required: false,
            default: () => { return [] },
        },
        showOldFile: {
            type: Boolean,
            default: false,
        },
        productsAndQr: {
            type: Array,
            default: () => ([]),
        },
        item: {
            type: Object,
            default: () => ({}),
        },
        selectedLocation: {
            type: Number,
            default: null,
        },
        selectedInstaller: {
            type: Number,
            default: null,
        },
        selectedCompany: {
            type: Number,
            default: null,
        },
        oldServices: {
            type: Array,
            default: () => ([]),
        },
        plannedFor: {
            type: String,
            default: null
        },
        plannedEnd: {
          type: String,
          default: null
        },
    },

    data() {
        return {
            hideInstalled: false,
            location: [],
            installer: [],
            company: [],
            products: [],
            selectedServices: [],
            selected_company: null,
            planned_for: null,
            planned_end: null,
            itemData: null,
            selected_installer: null,
            selected_location: null,
            files: [],
            productTypes: {
                return_revers: {
                    types: [],
                    equipment: [],
                },
                revers: {
                    types: [],
                    equipment: [],
                },
                service: {
                    types: [],
                    equipment: [],
                },
            },
            showFiles: this.showOldFile,
            isAbleToEdit: true,
        }
    },

    created() {
        if (this.item.status == 'install_ready' && (this.isWarehouseUser)) {
            this.isAbleToEdit = false;
        }

        this.selected_installer = this.selectedInstaller;
        this.selected_location = this.selectedLocation;
        this.selected_company = this.selectedCompany;
        this.selectedServices = this.oldServices;
        this.planned_for = this.plannedFor;
        this.planned_end = this.plannedEnd;
        this.itemData = this.item;
        this.products = this.productsAndQr;

        if (this.old) {
            this.selected_location = new Number(this.old.location_id);
            this.selected_company = new Number(this.old.company_id);
            this.selected_installer = new Number(this.old.installer_id);

            if (this.selected_installer) {
                this.fetchAvailableProducts('revers');
            }

            if (this.selected_location) {
                this.fetchAvailableProducts('return_revers');
                this.fetchAvailableProducts('service');
            }

            if (this.old.service) {
                this.selectedServices = this.old.service;

                if (this.selectedServices) {
                    this.selectedServices.map((ser) => {
                        ser.value = new Number(ser.id)

                        return ser
                    })
                }
            }

            if (this.old.planned_for) {
                this.planned_for = this.old.planned_for;
            }

            if (this.old.planned_end) {
                this.planned_end = this.old.planned_end;
            }

            // if (this.old.products) {
            //     this.products = this.old.products;

            //     if (this.products) {
            //         this.products.map((prod) => {
            //             let type = this.productTypes[prod.way].find(item => {
            //                 return item.id == prod.id
            //             })

            //             console.log(type)

            //             prod.type = type;
            //             prod.qr_codes = prod.qr_codes ? prod.qr_codes : []
            //             prod.label = prod.label ? prod.label : ''

            //             return prod;
            //         });
            //     }
            // }
        }

        this.initLocations();
        this.initProducts();
        this.initServices();
    },

    mounted() {
        if (this.item.status == 'installed' || this.item.status == 'installed_at') {
            this.hideInstalled = true
        }

        this.locationSearch('', '')
        this.initialInstallersSearch('', '')
        this.companySearch('', '')
    },

    methods: {
        removeQr(index, qrIndex) {
            let qrItem = this.products[index]['qr_codes'][qrIndex]

            this.products[index]['qr_codes'].splice(qrIndex, 1);
        },

        lessThanTwo() {
            return this.products.length < 2
        },

        removeProduct(index) {
            this.products.splice(index, 1)
        },

        removeService(index) {
            this.selectedServices.splice(index, 1)
        },

        processFile($event) {
            if (this.files.length == 0) {
                this.files = this.toArray($event.target.files)
                return
            }

            this.files = this.toArray(this.files).concat(this.toArray($event.target.files))
        },

        toArray(fileList) {
            return Array.prototype.slice.call(fileList);
        },

        chooseFile() {
            let element = 'tempFile'
            document.getElementById(element).click()
        },

        removePreUploadFile(file, index) {
            this.files.splice(index, 1)
        },

        removeFile(file) {
            axios.get(route('admin.delete.document'))
                .then((response) => {
                    document.querySelector('#file-' + file.id).remove()
                })
                .catch((error) => {
                    console.error(error);
                });
        },

        initProducts() {
            if (this.products.length === 0) {
                this.addNewProduct()
            }
        },

        initServices() {
            if (this.selectedServices.length === 0) {
                this.addNewService()
            }
        },

        initLocations() {
            this.fetchAvailableProducts('revers');
            this.fetchAvailableProducts('return_revers');
            this.fetchAvailableProducts('service');
        },

        addNewService() {
            this.selectedServices.push({
                value: null,
                quantity: 1,
            });
        },

        addNewProduct() {
            this.products.push({
                label: '',
                way: '',
                quantity: 0,
                mac_addresses: 0,
                type: null,
                qr_codes: [],
            });
        },

        fetchAvailableProducts(way) {
            let locationId = null;

            if (way == 'revers') {
                locationId = this.selected_installer;
            } else if (way == 'return_revers' || way == 'service') {
                locationId = this.selected_location;
            }

            if (!locationId) {
                return;
            }

            axios.get(route('admin.api.on-site-work-order.find-products', { location: locationId }))
                .then(response => {
                    this.productTypes[way].types = response.data.types;
                    this.productTypes[way].equipment = response.data.equipment;
                })
                .catch(error => {
                    console.error(error);
                })
        },

        locationSearch(search, loading) {
            this.isSearchLoading = true;

            fetch('/api/search/work-order-locations/' + escape(search))
                .then(res => res.json())
                .then(json => {
                    this.location = json.data;
                    this.isSearchLoading = false;
                })
                .catch(err => console.warn(err));
        },

        companySearch(search, loading) {
            this.isSearchLoading = true;

            fetch('/api/on-site-work-order/companies/' + escape(search))
                .then(res => res.json())
                .then(json => {
                    this.company = json.data;
                    this.isSearchLoading = false;
                })
                .catch(err => console.warn(err));
        },

        clearInstallerSelection () {
            this.selected_installer = '';
        },

        installersSearch(search, loading) {
            this.isInSearchLoading = true;

            fetch('/api/search/installers/' + this.selected_company + '/' + escape(search))
                .then(res => res.json())
                .then(json => {
                    this.installer = json.data;
                    this.isInSearchLoading = false;
                })
                .catch(err => console.warn(err));
        },

        initialInstallersSearch(search, loading) {
            this.isInSearchLoading = true;
            fetch('/api/search/installers/' + this.selected_company + '/' + escape(search))
                .then(res => res.json())
                .then(json => {
                    this.installer = json.data;
                    this.isInSearchLoading = false;
                })
                .catch(err => console.warn(err));
        },

        addEquipment(item) {
            if (item.type.id == item['selected_equipment'].product_id) {
                if (item['qr_codes'].length == item['quantity']) {
                    alert('Već su dodani svi QR kodovi za ' + item.type.title);
                } else if (item['qr_codes'].length > item['quantity']) {
                    alert('Već je dodano previše QR kodova za ' + item.type.title);
                } else if (
                    item['qr_codes'].length > 0 &&
                    item['qr_codes'].find(eq => eq.value == item['selected_equipment'].id)
                ) {
                    alert('Već je dodan uređaj ' + item['selected_equipment'].qr_code);
                } else {
                    item['qr_codes'].push({
                        label: item['selected_equipment'].title,
                        value: item['selected_equipment'].id,
                        code: item['selected_equipment'].qr_code,
                        serial_no: item['selected_equipment'].serial_no,
                        mac_address: item['selected_equipment'].mac_address,
                        mac_address2: item['selected_equipment'].mac_address2,
                    });
                }
            }
        },

        disableEdit() {
            return !(
                    this.itemData.status == 'draft' ||
                    this.itemData.status == 'install_ready' ||
                    this.itemData.status === undefined ||
                    (
                        this.isLead &&
                        this.itemData.status != 'installed_at' &&
                        this.itemData.status != 'installed'
                    )
                )
        },

        disableInstallerSelection() {
            return this.disableEdit() || !this.selected_company
        },
    },
}
</script>
